import styled from "styled-components";

export const SearchContainer = styled.div`
  width: 100%;
  max-width: ${(props) => (props.mode === "search" ? "600px" : "100%")};
  margin: ${(props) => (props.mode === "search" ? "20px auto" : "0")};
  position: relative;
  // background: ${(props) => (props.mode === "chat" ? "#F9F5E7" : "transparent")};
  padding: ${(props) => (props.mode === "chat" ? "16px" : "0")};
  border-top: ${(props) =>
    props.mode === "chat" ? "1px solid #E1D6B0" : "none"};
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: ${(props) =>
    props.mode === "search" ? "12px 48px 12px 20px" : "12px 48px 12px 20px"};
  font-size: 16px;
  border: 4px solid #c5a55c;
  border-radius: ${(props) => (props.mode === "search" ? "20px" : "20px")};
  transition: all 0.3s ease;
  background: ${(props) => (props.mode === "chat" ? "var(--navbar-bg)" : "var(--navbar-bg)")};
   color: ${(props) => (props.mode === "chat" ? "var(--tittle-text)" : " var(--tittle-text)")};

  &:focus {
    outline: none;
    border-color: #c5a55c;
    box-shadow: 0 0 0 2px rgba(212, 175, 55, 0.25);
  }
`;

export const LoadingIndicator = styled.div`
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  color: #7c7157;
  font-size: 14px;
`;

export const SendButton = styled.button`
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  color: ${(props) => (props.disabled ? "#c5a55c" : "#c5a55c")};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
  opacity: ${(props) => (props.disabled ? "0.5" : "1")};
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};

  &:hover {
    background: ${(props) =>
      props.disabled ? "none" : "rgba(212, 175, 55, 0.1)"};
  }

  &:active {
    transform: ${(props) =>
      props.disabled ? "translateY(-50%)" : "translateY(-50%) scale(0.95)"};
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;
